import { useState, useEffect } from 'react';
import { useGetLastTruckTrailerPairs } from 'api/trips/use-get-last-truck-trailer-pairs';
import type { TTruckTrailerPairsMap } from 'types/transport';
import type { IGetTruckTrailerPairsProps, IGetTruckTrailerPairsResult } from 'components/cargos/cargos-map-view/types';

export const useGetTruckTrailerPairs = (props: IGetTruckTrailerPairsProps): IGetTruckTrailerPairsResult => {
  const { transports, withTransport } = props;

  const [truckTrailerPairs, setTruckTrailerPairs] = useState<TTruckTrailerPairsMap | undefined>(undefined);
  const [isReady, setIsReady] = useState(false);

  const isSkip = !withTransport || !transports || transports.length === 0;

  const filteredTrucks = transports.filter((transports) => {
    return transports.subType === 'truck_head' || transports.subType === 'roadtrain';
  });

  const truckIds = filteredTrucks.map((transport) => transport.id);

  const { data: pairs } = useGetLastTruckTrailerPairs({ truckIds, isSkip });

  useEffect(() => {
    const result = pairs?.reduce<TTruckTrailerPairsMap>((acc, pair) => {
      return { ...acc, [pair.truckId]: pair };
    }, {});

    setTruckTrailerPairs(result);
    setIsReady(true);
  }, [pairs]);

  return {
    pairs: truckTrailerPairs,
    isReady,
  };
};
